import React from 'react';
import { render } from 'react-dom';
import { makeData, Logo, Tips, round } from '../Utility/utility.js';
import { Button } from 'react-bootstrap';
import { ContractTable } from './ContractTable';
import { VideoWrapper } from './VideoWrapper';
import { ShotChart } from '../Components/ShotChart';
import './PlayerCard.css';
import latinize from 'latinize';
import ordinal from 'ordinal';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
// Import React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';

export const navigatePage = () => dispatch => {
  /* do something before redirection */
  console.log('navigating');
  dispatch(push('/trade'));
};

class PlayerCard extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
    let first = latinize(
      this.props.selectedPlayer.player_name
        .split(' ')[0]
        .toLowerCase()
        .replace('.', '')
        .replace('.', '')
    );
    let last = latinize(
      this.props.selectedPlayer.player_name.split(' ')[1].toLowerCase()
    );

    this.state = {
      imgSrc:
        'https://tsnimages.tsn.ca/ImageProvider/PlayerHeadshot?seoId=' +
        first +
        '-' +
        last +
        '&width=136&height=136',
      columns: this.playerStatsColumns,
      data: this.props.selectedPlayer.stats,
      pageSize: this.props.selectedPlayer.stats.length,
      videos: this.props.selectedPlayer.videos,
      selectedVideo:
        this.props.selectedPlayer.videos.length > 0
          ? this.props.selectedPlayer.videos[0]
          : '',
      showTable: true,
      shotType: 0
    };
    this.playVideo = this.playVideo.bind(this);
  }
  componentDidUpdate() {
    let first = latinize(
      this.props.selectedPlayer.player_name
        .split(' ')[0]
        .toLowerCase()
        .replace('.', '')
        .replace('.', '')
    );
    let last = latinize(
      this.props.selectedPlayer.player_name.split(' ')[1].toLowerCase()
    );
    //console.log(first, last);
    let src =
      'https://tsnimages.tsn.ca/ImageProvider/PlayerHeadshot?seoId=' +
      first +
      '-' +
      last +
      '&width=136&height=136';

    if (src != this.state.imgSrc) {
      this.setState({ imgSrc: src });
      this.changeColumns('stat');
    }
    if (this.state.selectedVideo != this.props.selectedPlayer.videos[0]) {
      this.setState({ selectedVideo: this.props.selectedPlayer.videos[0] });
    }
  }
  playVideo(video, index) {
    let currentComponent = this;
    console.log('playing video');
    console.log(video);
    console.log(index);
    currentComponent.setState({
      selectedVideo: video
    });
  }
  playerStatsColumns = [
    {
      Header: 'Season',
      id: 'season',
      accessor: d => d.season,
      minWidth: 90
    },
    {
      Header: 'Team',
      id: 'team',
      accessor: d => d.team,
      minWidth: 50
    },
    {
      Header: 'Type',
      id: 'season_type',
      accessor: d => (d.season_type === '02' ? 'Reg' : 'P/O'),
      minWidth: 50
    },
    {
      Header: 'GP',
      id: 'gp',
      accessor: d => d.games_played,
      minWidth: 50
    },
    {
      Header: 'ATOI',
      id: 'atoi',
      accessor: d => (d.toi ? (d.toi / d.games_played).toFixed(2) : null),
      minWidth: 60
    },
    {
      Header: 'G',
      id: 'g',
      accessor: d => d.goals,
      minWidth: 50
    },
    {
      Header: 'A',
      id: 'assists',
      accessor: d => d.assists,
      minWidth: 50
    },
    {
      Header: 'P',
      id: 'points',
      accessor: d => d.points,
      minWidth: 50
    },
    {
      Header: 'SOG',
      id: 'shots',
      accessor: d => d.shots,
      minWidth: 60
    },
    {
      Header: 'CF%',
      id: 'corsi_pct',
      accessor: d => (d.corsi_pct ? d.corsi_pct.toFixed(2) : null),
      minWidth: 60
    }
  ];
  goalieStatsColumns = [
    {
      Header: 'Season',
      id: 'season',
      accessor: d => d.season,
      minWidth: 90
    },
    {
      Header: 'Type',
      id: 'season_type',
      accessor: d => (d.season_type === '02' ? 'Reg' : 'P/O'),
      minWidth: 50
    },
    {
      Header: 'GP',
      id: 'gp',
      accessor: d => d.games_played,
      minWidth: 75
    },
    {
      Header: 'ATOI',
      id: 'atoi',
      accessor: d =>
        d.toi / d.games_played ? (d.toi / d.games_played).toFixed(2) : null,
      minWidth: 75
    },
    {
      Header: 'GAA',
      id: 'gaa',
      accessor: d => (d.gaa ? d.gaa.toFixed(3) : null),
      minWidth: 75
    },
    {
      Header: 'SV%',
      id: 'sv_pct',
      accessor: d => (d.sv_pct ? d.sv_pct.toFixed(4) : null),
      minWidth: 75
    },
    {
      Header: 'CF%',
      id: 'cf_pct',
      accessor: d => (d.cf_pct ? d.cf_pct.toFixed(2) : null),
      minWidth: 75
    }
  ];
  salaryColumns = [
    {
      Header: 'Season',
      id: 'season',
      accessor: d => (d.cap_hit ? d.season : null),
      minWidth: 90
    },
    {
      Header: 'Cap Hit',
      id: 'cap_hit',
      accessor: d => (d.cap_hit ? '$' + d.cap_hit.toLocaleString() : null),
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      minWidth: 90
    },
    {
      Header: 'AAV',
      id: 'aav',
      accessor: d => (d.aav ? '$' + d.aav.toLocaleString() : null),
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      minWidth: 90
    },
    {
      Header: 'Total',
      id: 'total_salary',
      accessor: d =>
        d.total_salary ? '$' + d.total_salary.toLocaleString() : null,
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      minWidth: 90
    },
    {
      Header: 'Status',
      id: 'status',
      accessor: d => d.expiry_status,
      minWidth: 60
    },
    {
      Header: 'Years Left',
      id: 'years_remaining',
      accessor: d => d.years_remaining,
      minWidth: 60
    }
  ];
  henriColumns = [
    {
      Header: 'Season',
      id: 'season',
      accessor: d => (d.henri || d.cap_hit ? d.season : null),
      minWidth: 120
    },
    {
      Header: 'Cap Hit',
      id: 'cap_hit',
      accessor: d => (d.cap_hit ? '$' + d.cap_hit.toLocaleString() : null),
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      minWidth: 120
    },
    {
      Header: 'HENRI',
      id: 'henri',
      accessor: d => (d.henri ? '$' + d.henri.toLocaleString() : null),
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      minWidth: 120
    },
    {
      Header: 'Surplus',
      id: 'surplus',
      accessor: d => (d.surplus ? '$' + d.surplus.toLocaleString() : null),
      sortMethod: (a, b, desc) => {
        a =
          a === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                a
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        b =
          b === null
            ? desc
              ? -Infinity
              : Infinity
            : Number(
                b
                  .split('$')[1]
                  .split(',')
                  .join('')
              );
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      },
      minWidth: 120
    }
  ];

  openExpand(e) {
    console.log('executing expand');
    this.props.dispatch(
      push('/players?player_id=' + this.props.selectedPlayer.player_id)
    );
  }
  // handleChange(val) {
  //   this.setState({
  //     shotType: val
  //   });
  // }

  changeColumns(e) {
    console.log('changing column');
    console.log(e);
    if (e == 'sal') {
      this.setState({
        showTable: true,
        columns: this.salaryColumns,
        data: this.props.selectedPlayer.contract_info,
        showShots: false,
        pageSize: this.props.selectedPlayer.contract_info.length
      });
      document.getElementById('stat').classList.remove('active');
      document.getElementById('sal').classList.add('active');
      document.getElementById('h').classList.remove('active');
      document.getElementById('shtcht').classList.remove('active');
      document.getElementById('v').classList.remove('active');
    } else if (e == 'stat') {
      if (this.props.selectedPlayer.position == 'G') {
        this.setState({
          showTable: true,
          columns: this.goalieStatsColumns,
          data: this.props.selectedPlayer.stats,
          showShots: false,
          pageSize: this.props.selectedPlayer.stats.length
        });
        document.getElementById('stat').classList.add('active');
        document.getElementById('sal').classList.remove('active');
        document.getElementById('h').classList.remove('active');
        document.getElementById('shtcht').classList.remove('active');
        document.getElementById('v').classList.remove('active');
      } else {
        this.setState({
          showTable: true,
          columns: this.playerStatsColumns,
          data: this.props.selectedPlayer.stats,
          showShots: false,
          pageSize: this.props.selectedPlayer.stats.length
        });
        document.getElementById('stat').classList.add('active');
        document.getElementById('sal').classList.remove('active');
        document.getElementById('h').classList.remove('active');
        document.getElementById('shtcht').classList.remove('active');
        document.getElementById('v').classList.remove('active');
      }
    } else if (e == 'h') {
      this.setState({
        showTable: true,
        columns: this.henriColumns,
        data: this.props.selectedPlayer.contract_info,
        showShots: false,
        pageSize: this.props.selectedPlayer.contract_info.length
      });
      document.getElementById('stat').classList.remove('active');
      document.getElementById('sal').classList.remove('active');
      document.getElementById('h').classList.add('active');
      document.getElementById('shtcht').classList.remove('active');
      document.getElementById('v').classList.remove('active');
    } else if (e == 'vid') {
      console.log('showing video');
      this.setState({
        //columns: this.henriColumns,
        data: [],
        showTable: false,
        showShots: false
        //pageSize: this.props.selectedPlayer.contract_info.length
      });
      document.getElementById('stat').classList.remove('active');
      document.getElementById('sal').classList.remove('active');
      document.getElementById('h').classList.remove('active');
      document.getElementById('shtcht').classList.remove('active');
      document.getElementById('v').classList.add('active');
    } else if (e == 'shtcht') {
      console.log('showing Shot Chart');
      this.setState({
        //columns: this.henriColumns,
        data: [],
        showTable: false,
        showShots: true
        //pageSize: this.props.selectedPlayer.contract_info.length
      });
      document.getElementById('stat').classList.remove('active');
      document.getElementById('sal').classList.remove('active');
      document.getElementById('h').classList.remove('active');
      document.getElementById('v').classList.remove('active');
      document.getElementById('shtcht').classList.add('active');
    }
  }

  render() {
    const { data } = this.state;
    var dict = this.props.dict;
    var arr = [];

    for (var key in dict) {
      arr.push(dict[key]);
    }
    return (
      <div
        className="player-card"
        style={{ display: 'flex', maxHeight: '40em', overflowY: 'auto' }}
      >
        <div
          style={{
            borderRight: '1px solid #61696e',
            flex: 2,
            justifyContent: 'space-between'
          }}
        >
          <div
            style={{
              background: '#61696e',
              padding: '0.3em 1em',
              color: 'white'
            }}
          >
            <strong>Player Card</strong>
          </div>
          <div className="bio">
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
              <img
                src={this.state.imgSrc}
                alt="Smiley face"
                width="136"
                height="136"
              />
            </div>
            <div className="info">
              <h4 className="player-name">
                {this.props.selectedPlayer.player_name}
              </h4>
              <ul className="first-stats">
                <li>{this.props.selectedPlayer.position}</li>
                <li>{this.props.selectedPlayer.height}</li>
                <li>{this.props.selectedPlayer.weight}</li>
                <li style={{ border: 'none' }}>
                  Age: {this.props.selectedPlayer.age}
                </li>
              </ul>
              <div
                style={{
                  textAlign: 'center',
                  marginBottom: '1em',
                  alignItems: 'center'
                }}
              >
                <img
                  src={
                    'https://tsnimages.tsn.ca/ImageProvider/TeamLogo?seoId=' +
                    latinize(this.props.selectedPlayer.team_name)
                      .replace(' ', '-')
                      .replace(' ', '-')
                      .toLowerCase()
                  }
                  alt="team logo"
                  width="40"
                  height="40"
                />
                <strong style={{ fontSize: '16px', marginLeft: '0.5em' }}>
                  {this.props.selectedPlayer.team_name}
                </strong>
              </div>
            </div>
          </div>
          <div>
            <ul className="second-stats">
              <li>
                <strong>Born:</strong> {this.props.selectedPlayer.birthdate}
              </li>
              <li>
                <strong>Birthplace:</strong>{' '}
                {this.props.selectedPlayer.birthplace}
              </li>
              <li>
                <strong>Draft: </strong>
                {this.props.selectedPlayer.draft_year}
                {this.props.selectedPlayer.draft_year != 'Undrafted' && (
                  <span> {this.props.selectedPlayer.drafted_by},</span>
                )}
                {this.props.selectedPlayer.draft_year != 'Undrafted' && (
                  <span> Round: {this.props.selectedPlayer.draft_round}, </span>
                )}
                {this.props.selectedPlayer.draft_year != 'Undrafted' && (
                  <span>
                    {' '}
                    {ordinal(this.props.selectedPlayer.draft_overall)} overall
                  </span>
                )}
              </li>
              <li>
                <strong>Shoots:</strong> {this.props.selectedPlayer.handedness}
              </li>
            </ul>
          </div>
          <div className="listButtons" style={{ textAlign: 'center' }}>
            {/*
                            <Button id="listAdd" onClick={document.addEventListener("DOMContentLoaded", function(event) {
                                document.getElementById("listAdd").addEventListener('click', function(){
                                        document.getElementById("myList").innerHTML +=
                                            "<li>" + document.getElementById("player-name").innerText + "</li>"
                                    }
                                );
                            })} style={{margin: '0 1em 1em'}}>+ Add</Button>
                            <Button id="listDelete" onClick={function() {
                                        for (var i = 0; i < document.getElementById("myList").children.length; i++) {
                                            if (document.getElementById("myList").children[i].innerText === document.getElementById("player-name").innerText) {
                                                document.getElementById("myList").children[i].remove();
                                            }
                                        }
                                    }}
                                    style={{margin: '0 1em 1em'}}>- Remove
                            </Button>
            */}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 3 }}>
          <table className="table-headers">
            <tr>
              <th
                id="stat"
                className={'active'}
                onClick={e => this.changeColumns('stat')}
              >
                Stats
              </th>
              <th id="sal" onClick={e => this.changeColumns('sal')}>
                Salary
              </th>
              <th id="h" onClick={e => this.changeColumns('h')}>
                HENRI
              </th>
              <th id="v" onClick={e => this.changeColumns('vid')}>
                Video
              </th>
              <th id="shtcht" onClick={e => this.changeColumns('shtcht')}>
                Shot Chart
              </th>
              <th id="ex" onClick={e => this.openExpand('ex')}>
                Expand
              </th>
            </tr>
          </table>
          {this.state.data &&
            this.state.showTable && (
              <ReactTable
                data={this.state.data}
                filterable={false}
                showPagination={false}
                defaultSortDesc={true}
                defaultSorted={[{ id: 'season', desc: true }]}
                ref="playerCardTable"
                columns={this.state.columns}
                pageSize={this.state.pageSize}
                className="-striped -highlight"
              />
            )}
          {!this.state.showTable &&
            !this.state.showShots &&
            this.state.selectedVideo && (
              <VideoWrapper selectedVideo={this.state.selectedVideo} />
            )}
          {this.state.showShots &&
            !this.state.showTable && (
              <div style={{ marginLeft: '35px' }}>
                <ShotChart player_id={this.props.selectedPlayer.player_id} />
              </div>
            )}
          {/*this.state.videos.length > 0 &&
            !this.state.showTable &&
            !this.state.selectedVideo &&
            this.state.videos.map((video, index) => (
              <div style={{ paddingRight: '10px' }}>
                <div
                  style={{ fontSize: '20px' }}
                  onClick={() => this.playVideo(video, index)}
                >
                  {video.description}-{video.uploaded_by}
                </div>
              </div>
            ))*/}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    state
  };
}

const connectedPlayerCard = connect(mapStateToProps)(PlayerCard);
export { connectedPlayerCard as PlayerCard };



// WEBPACK FOOTER //
// ./src/Components/PlayerCard.js